<style>
	@import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="" title="Products" />

		<div class="container-fluid">
			<div class="row">
				<div class="col-sm-12">
					<div class="card">
						<div class="card-body">

							<div class="col-md-12 project-list page-subtitle">
								<div class="row">
									<div class="col-md-12">
										<button class="btn btn-primary float-end" type="button" @click="openProductModal">Add Product</button>
									</div>
								</div>
							</div>

							<div class="col-md-12 project-list filter-sort">
								<div class="row">
									<div class="col-md-8 d-flex mt-2">
										<label class="d-flex listing-length ms-1"><span>Show</span>
											<select class="form-select" v-model="listing_length" @change="fetchProducts()">
												<option value="5">5</option>
												<option value="10">10</option>
												<option value="20">20</option>
											</select>
											<span>entries</span>
										</label>
									</div>
									<div class="col-md-2 mt-2">
										<select class="form-select" v-model="status" @change="fetchProducts()">
											<option value="">All</option>
											<option value="1">Active</option>
											<option value="2">Blocked</option>
										</select>
									</div>
									<div class="col-md-2 mt-2">
										<input type="text" class="form-control ms-1" placeholder="Search" v-model="keyword" @keyup="fetchProducts()" />
									</div>
								</div>
							</div>

							<div class="table-responsive product-table">
								<table class="display" id="basic-1">
									<thead>
										<tr align="center">
											<th>Sl.No</th>
											<th>Product Name</th>
											<th>Image</th>
											<th>Stock</th>
											<th>Status</th>
											<th>Action</th>
										</tr>
									</thead>
									<tbody v-if="Boolean(products.length)">
										<tr align="center" v-for="(product, index) in products" :key="product.id">
											<td>{{ from + index }}</td>
											<td>{{ product.product_name }}</td>
											<td>
												<img
													v-if="product.image"
													:src="$image_url + product.image"
													alt=""
													height="50"
													width="50"
													class="rounded"
													style="object-fit: cover;"
												/>
												<span v-else>—</span>
											</td>
											<td>{{ product.current_stock }}</td>
											<td>
												<span class="badge rounded-pill bg-success" v-if="product.status == 1">Active</span>
												<span class="badge rounded-pill bg-danger" v-if="product.status == 2">Blocked</span>
											</td>
											<td>
												<button class="btn btn-primary btn-sm me-1 mb-2" @click="editProduct(product)">Edit</button>
												<button class="btn btn-info btn-sm me-1 mb-2" @click="openStockModal(product)">Update Stock</button>
												<button
													v-if="product.status == 1"
													class="btn btn-warning btn-sm me-1 mb-2"
													@click="confirmStatusChange(product, 2)"
												>Block</button>
												<button
													v-if="product.status == 2"
													class="btn btn-success btn-sm me-1 mb-2"
													@click="confirmStatusChange(product, 1)"
												>Activate</button>
												<router-link
													:to="{ name: 'product_stock_logs', params: { id: product.id } }"
													class="btn btn-primary btn-sm me-1 mb-2"
												>Stock Logs</router-link>
											</td>
										</tr>
									</tbody>
									<tbody v-else>
										<tr>
											<td colspan="6" align="center">No data available</td>
										</tr>
									</tbody>
								</table>
							</div>

							<caption v-if="Boolean(products.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{ from }} to {{ to }} of {{ total }} entries</caption>
							<nav aria-label="Page navigation" class="mt-2 float-end">
								<ul class="pagination">
									<li
										class="page-item"
										v-bind:class="[{ disabled: !page.url }, { active: page.active }]"
										v-for="(page, index) in pagination"
										:key="page.label"
									>
										<a
											class="page-link"
											href="#"
											@click.prevent="fetchProducts(page.url + '&limit=' + listing_length + '&status=' + status + '&keyword=' + keyword)"
											tabindex="-1"
										>
											<span v-if="index == 0">Prev</span>
											<span v-else-if="index == pagination.length - 1">Next</span>
											<span v-else>{{ page.label }}</span>
										</a>
									</li>
								</ul>
							</nav>

						</div>
					</div>
				</div>
			</div>
		</div>

		<DynamicModal :title="product_modal_title">
			<template #body>
				<form @submit.prevent="submitProduct" enctype="multipart/form-data">
					<div class="row mt-2">
						<div class="col-md-12 form-group">
							<label class="control-label">Product Name<span class="text-danger">*</span></label>
							<input class="form-control" v-model="productForm.name" type="text" :disabled="edit" />
						</div>
					</div>

					<div class="row mt-2" v-if="!edit">
						<div class="col-md-12 form-group">
							<label class="control-label">Stock<span class="text-danger">*</span></label>
							<input class="form-control" v-model="productForm.stock" type="number" min="0" />
						</div>
					</div>

					<div class="row mt-2">
						<div class="col-md-12 form-group">
							<label class="control-label">Image<span class="text-danger" v-if="!edit">*</span></label>
							<input class="form-control" type="file" accept="image/*" @change="onImageChange" />
							<img
								v-if="imagePreview"
								:src="imagePreview"
								alt=""
								height="80"
								width="80"
								class="mt-2 rounded"
								style="object-fit: cover;"
							/>
						</div>
					</div>

					<div class="col-md-12 form-group mt-3">
						<button type="submit" class="btn btn-primary me-3" :disabled="submitting">
							<span v-if="submitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
							{{ submitting ? "Saving..." : product_button_title }}
						</button>
						<button type="button" class="btn btn-light" @click="closeProductModal()" :disabled="submitting">Close</button>
					</div>
				</form>
			</template>
		</DynamicModal>

		<div class="modal fade" id="productStockModal" tabindex="-1" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Update Stock</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="closeStockModal"></button>
					</div>
					<div class="modal-body">
						<form @submit.prevent="submitStockUpdate">
							<p class="mb-2"><strong>{{ stockProductName }}</strong></p>
							<p class="text-muted small mb-3">Current stock: {{ stockCurrent }}</p>
							<div class="row">
								<div class="col-md-12 form-group mt-2">
									<label class="control-label">Type<span class="text-danger">*</span></label>
									<select class="form-select" v-model="stockForm.type">
										<option value="">--Select--</option>
										<option value="1">Add Stock</option>
										<option value="2">Debit Stock</option>
									</select>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12 form-group mt-2">
									<label class="control-label">Stock<span class="text-danger">*</span></label>
									<input v-model="stockForm.stock" class="form-control" type="number" min="1" />
								</div>
							</div>
							<div class="col-md-12 form-group mt-3">
								<button type="submit" class="btn btn-primary me-3" :disabled="stockSubmitting">
									<span v-if="stockSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
									{{ stockSubmitting ? "Saving..." : "Update" }}
								</button>
								<button type="button" class="btn btn-light" @click="closeStockModal" :disabled="stockSubmitting">Close</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { Modal } from "bootstrap";
import DynamicModal from "@/components/dynamic_modal.vue";

export default {
	name: "ProductsPage",
	components: {
		DynamicModal,
	},
	data() {
		return {
			dynamicmodal: null,
			stockModal: null,

			product_modal_title: "Add Product",
			product_button_title: "Save",

			keyword: "",
			listing_length: 10,
			token: "",
			status: "",
			submitting: false,
			stockSubmitting: false,
			errors: {},

			products: [],
			pagination: [],
			from: 0,
			to: 0,
			total: 0,
			active_page_url: null,

			edit: false,
			productForm: {
				product_id: "",
				name: "",
				stock: "",
			},
			imageFile: null,
			imagePreview: null,

			stockProductId: null,
			stockProductName: "",
			stockCurrent: 0,
			stockForm: {
				type: "",
				stock: "",
			},
		};
	},
	mounted() {
		this.dynamicmodal = new Modal(document.getElementById("dynamicmodal"));
		const stockEl = document.getElementById("productStockModal");
		if (stockEl) this.stockModal = new Modal(stockEl);
	},
	created() {
		this.fetchProducts();
	},
	methods: {
		isApiSuccess(data) {
			return data.status === true || data.status === "true" || data.success === true || data.success === "true";
		},

		getToken() {
			if (localStorage.getItem("airotrack_staff")) {
				const airotrack_staff = JSON.parse(localStorage.getItem("airotrack_staff"));
				if (airotrack_staff.token) {
					this.token = airotrack_staff.token;
				} else {
					this.$swal("", "Failed to fetch token, please login again", "error");
					this.$router.push({ name: "login" });
				}
			} else {
				this.$swal("", "Session expired, please login again", "error");
				this.$router.push({ name: "login" });
			}
		},

		fetchProducts(page_url = null) {
			this.getToken();
			const url =
				"/staffs/products?limit=" +
				this.listing_length +
				"&status=" +
				this.status +
				"&keyword=" +
				this.keyword;
			page_url = page_url || url;
			this.active_page_url = page_url;
			this.$axios
				.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
				.then((res) => {
					const responseData = res.data.data;
					this.products = responseData.data || [];
					this.pagination = responseData.links || [];
					this.from = responseData.from || 0;
					this.to = responseData.to || 0;
					this.total = responseData.total || 0;
				})
				.catch((err) => console.log(err));
		},

		openProductModal() {
			this.clearProductForm();
			this.dynamicmodal?.show();
		},

		closeProductModal() {
			this.dynamicmodal?.hide();
		},

		editProduct(product) {
			this.edit = true;
			this.errors = {};
			this.product_modal_title = "Edit Product";
			this.product_button_title = "Update";
			this.productForm = {
				product_id: product.id,
				name: product.product_name,
				stock: "",
			};
			this.imageFile = null;
			this.imagePreview = product.image ? this.$image_url + product.image : null;
			this.dynamicmodal?.show();
		},

		onImageChange(event) {
			const file = event.target.files[0];
			if (file) {
				this.imageFile = file;
				this.imagePreview = URL.createObjectURL(file);
			}
		},

		submitProduct() {
			if (this.submitting) return;
			this.submitting = true;
			this.getToken();
			const formData = new FormData();
			formData.append("name", this.productForm.name);
			if (this.imageFile) {
				formData.append("image", this.imageFile);
			}
			const config = {
				headers: {
					"content-type": "multipart/form-data",
					Authorization: "Bearer " + this.token,
				},
			};
			let url;
			if (!this.edit) {
				formData.append("stock", this.productForm.stock);
				url = "/staffs/addProduct";
			} else {
				formData.append("product_id", this.productForm.product_id);
				url = "/staffs/updateProduct";
			}
			this.$axios
				.post(url, formData, config)
				.then((response) => {
					if (this.isApiSuccess(response.data)) {
						this.$swal("", response.data.message, "success");
					} else {
						this.$swal("", response.data.message, "error");
					}
					this.clearProductForm();
					this.closeProductModal();
					this.fetchProducts(this.active_page_url);
				})
				.catch((error) => {
					if (error.response?.data?.message) {
						this.$swal("", error.response.data.message, "error");
					} else {
						this.$swal("", "Something went wrong", "error");
					}
				})
				.finally(() => {
					this.submitting = false;
				});
		},

		clearProductForm() {
			this.edit = false;
			this.product_modal_title = "Add Product";
			this.product_button_title = "Save";
			this.productForm = { product_id: "", name: "", stock: "" };
			this.imageFile = null;
			this.imagePreview = null;
			this.errors = {};
		},

		openStockModal(product) {
			this.stockProductId = product.id;
			this.stockProductName = product.product_name;
			this.stockCurrent = product.current_stock;
			this.stockForm = { type: "", stock: "" };
			this.stockModal?.show();
		},

		closeStockModal() {
			this.stockModal?.hide();
		},

		submitStockUpdate() {
			if (this.stockSubmitting) return;
			this.stockSubmitting = true;
			this.getToken();
			const formData = new FormData();
			formData.append("product_id", this.stockProductId);
			formData.append("type", this.stockForm.type);
			formData.append("stock", this.stockForm.stock);
			const config = {
				headers: {
					"content-type": "multipart/form-data",
					Authorization: "Bearer " + this.token,
				},
			};
			this.$axios
				.post("/staffs/updateProductStock", formData, config)
				.then((response) => {
					if (this.isApiSuccess(response.data)) {
						this.$swal("", response.data.message, "success");
					} else {
						this.$swal("", response.data.message, "error");
					}
					this.closeStockModal();
					this.fetchProducts(this.active_page_url);
				})
				.catch((error) => {
					if (error.response?.data?.message) {
						this.$swal("", error.response.data.message, "error");
					} else {
						this.$swal("", "Something went wrong", "error");
					}
				})
				.finally(() => {
					this.stockSubmitting = false;
				});
		},

		confirmStatusChange(product, status) {
			const isBlock = status === 2;
			this.$swal({
				icon: "warning",
				title: "Confirm",
				text: isBlock
					? "Are you sure you want to block this product?"
					: "Are you sure you want to activate this product?",
				showCancelButton: true,
				confirmButtonText: "Yes",
				confirmButtonColor: "#e64942",
				cancelButtonText: "No",
				position: "center",
				showConfirmButton: true,
				timer: "",
				toast: false,
				cancelButtonColor: "#efefef",
			}).then((result) => {
				if (result.value) {
					this.updateProductStatus(product.id, status);
				}
			});
		},

		updateProductStatus(productId, status) {
			this.getToken();
			const config = {
				headers: {
					"Content-type": "application/json",
					Accept: "application/json",
					Authorization: "Bearer " + this.token,
				},
			};
			const url = "/staffs/updateStatus?product_id=" + productId + "&status=" + status;
			this.$axios
				.get(url, config)
				.then((response) => {
					if (this.isApiSuccess(response.data)) {
						this.$swal("", response.data.message, "success");
					} else {
						this.$swal("", response.data.message, "error");
					}
					this.fetchProducts(this.active_page_url);
				})
				.catch((error) => {
					if (error.response?.data?.message) {
						this.$swal("", error.response.data.message, "error");
					} else {
						this.$swal("", "Something went wrong", "error");
					}
				});
		},
	},
};
</script>
